module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: _vm.activeClass,
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', [_vm._t("title", [_vm._v(_vm._s(_vm._title))])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.hasFooter) ? _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.hasOK) ? _c('span', [_c('button', {
    class: _vm._okStyle,
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.$emit('ok')
      }
    }
  }, [_vm._v(_vm._s(_vm._okText))])]) : _vm._e(), _vm._v(" "), (_vm.hasCancel) ? _c('span', [_c('button', {
    class: _vm._cancelStyle,
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm._cancelText))])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a4d90128!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-modal.vue
// module id = 460
// module chunks = 0